module.exports = __webpack_public_path__ + "static/media/photo.56b1bd6e.png";